import { render, staticRenderFns } from "./ActionDiagnosticoPorRevisar.vue?vue&type=template&id=b13b08f2&scoped=true&lang=pug"
import script from "./ActionDiagnosticoPorRevisar.vue?vue&type=script&lang=js"
export * from "./ActionDiagnosticoPorRevisar.vue?vue&type=script&lang=js"
import style0 from "./ActionDiagnosticoPorRevisar.vue?vue&type=style&index=0&id=b13b08f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13b08f2",
  null
  
)

export default component.exports